import { __, invertObj, prop } from 'ramda';

import { FINANCIAL_PUBLICATION, PUBLICATION } from '../../../types/filters';

export const PRISMIC_TO_TYPE_PUBLICATION = {
  'Résultats annuels': FINANCIAL_PUBLICATION.FULL_YEAR_RESULTS,
  'Résultats semestriels': FINANCIAL_PUBLICATION.HALF_RESULTS,
  'Présentations investisseurs': FINANCIAL_PUBLICATION.INVESTOR_PRESENTATIONS,
  'Document d’enregistrement universel': FINANCIAL_PUBLICATION.URD,
  'Documents de référence': FINANCIAL_PUBLICATION.REFERENCE_DOCUMENT,
  'Rapports RSE': FINANCIAL_PUBLICATION.RSE_REPORT,
  'Green Bond': FINANCIAL_PUBLICATION.GREEN_BOND,

  "Rapports d'activité": PUBLICATION.ACTIVITY_REPORT,
  'Rapports sociaux': PUBLICATION.SOCIAL_REPORT,
  'Mémentos thématiques': PUBLICATION.THEME_MEMENTO,
  'Etudes & baromètres': PUBLICATION.STUDY_BAROMETRE,
  'Livres blancs': PUBLICATION.WHITE_PAPER,
  'Cahiers thématiques Postéo': PUBLICATION.POSTEO_BOOK,
  'Magazines régionaux Postéo': PUBLICATION.POSTEO_MAGAZINE,
};

export const toPublicationType = prop(__, PRISMIC_TO_TYPE_PUBLICATION);
export const toPublicationPrismic = prop(
  __,
  invertObj(PRISMIC_TO_TYPE_PUBLICATION)
);
